import { Pipe, PipeTransform } from '@angular/core';
import { RESOURCE_TYPE } from '@constants/ResourceType';
type FILE_TYPE_ICON = 'active' | 'default' | 'variant';

@Pipe({
  name: 'resourceTypeIcon',
})
export class ResourceTypePipe implements PipeTransform {
  private readonly ICONS: { [key: number]: { [key in 'active' | 'default' | 'variant']: string } } = {
    [RESOURCE_TYPE.images]: { active: 'fas fa-image', default: 'far fa-image', variant: 'far fa-image' },
    [RESOURCE_TYPE.videos]: { active: 'fas fa-video', default: 'far fa-video', variant: 'far fa-film' },
    [RESOURCE_TYPE.documents]: { active: 'fas fa-file-invoice', default: 'far fa-file-invoice', variant: 'far fa-file-invoice' },
    [RESOURCE_TYPE.audios]: { active: 'fas fa-volume', default: 'far fa-volume', variant: 'far fa-waveform' },
    [RESOURCE_TYPE.others]: { active: 'fas fa-scrubber', default: 'far fa-scrubber', variant: 'far fa-scrubber' },
  };

  transform(value: number, args: FILE_TYPE_ICON = 'default'): string {
    const icons = this.ICONS[value] || {};
    const icon = icons[args] || 'fas fa-scrubber';
    return icon;
  }
}